<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss">
</style>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["isAuthenticated"]),
  },
  mounted() {
    let that = this;
    this.$store.commit("initializeCredentials");
    this.$router.beforeEach((to, from, next) => {
      if (to.name !== "login" && !that.isAuthenticated) {
        next(false);
      } else {
        next();
      }
    });

    console.log(
      "%c VERSION: 1.0",
      "background: black; color: lime; display: block;"
    );
  },
};
</script>
